import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push, get } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  import base64 from 'react-native-base64';
  import AccessKey from '../other/AccessKey';

  // Normaliza placa no cliente (igual ao servidor): maiúsculas + só alfanumérico.
  const normPlate = (v) => (v ? String(v).replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : '');

  // Reserva atômica da placa via Cloud Function (índice unique_plate).
  // Retorna { success } ou { success:false, error:'plate_already_exists' | ... }.
  const requestUpdateVehiclePlate = async (carId, placa) => {
    const { config } = firebase;
    const projectId = config.projectId;
    const url = `https://us-central1-${projectId}.cloudfunctions.net/update_vehicle_plate`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Basic " + base64.encode(projectId + ":" + AccessKey)
        },
        body: JSON.stringify({ carId, placa })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.error || result.ok !== true) {
        return { success: false, error: result.error || `http_${response.status}` };
      }
      return { success: true };
    } catch (e) {
      return { success: false, error: 'network_error' };
    }
  };

  export const getDriverActiveCar = async (uid, carImage) => {
    if (!uid) return null;
    const { carsRef } = firebase;
    const snap = await get(carsRef(uid, 'driver'));
    if (!snap.exists()) return null;
    const data = snap.val();
    const cars = Object.keys(data).map((id) => ({ id, ...data[id] }));
    let match = carImage ? cars.find((c) => c.car_image === carImage) : null;
    if (!match) {
      match = cars
        .filter((c) => c.active)
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))[0] || null;
    }
    return match;
  };
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  // editCar com unicidade de PLACA (índice unique_plate). Use nas telas de cadastro/edição
  // de veículo. Retorna { success, id? } ou { success:false, error:'plate_already_exists' }.
  export const editCarUnique = (car, method) => async (dispatch) => {
    const { carAddRef, carEditRef } = firebase;
    const norm = normPlate(car.placa);

    // Guarda local imediata contra placas já carregadas na lista (mesmo usuário ou geral)
    if (norm) {
      const existingCars = store.getState().carlistdata?.cars || [];
      const targetId = method === 'Add' ? null : car.id;
      const duplicateLocal = existingCars.find(
        (c) => c && c.id !== targetId && normPlate(c.placa) === norm
      );
      if (duplicateLocal) {
        return { success: false, error: 'plate_already_exists' };
      }
    }

    if (method === 'Add') {
      const carId = push(carAddRef).key;
      const placa = car.placa ? String(car.placa) : '';
      if (placa) {
        const claim = await requestUpdateVehiclePlate(carId, placa);
        if (!claim.success) {
          return { success: false, error: claim.error === 'plate_already_exists' ? 'plate_already_exists' : (claim.error || 'plate_check_failed') };
        }
      }
      const toSave = { ...car };
      if (norm) toSave.placa = norm;
      delete toSave.tableData;
      set(child(carAddRef, carId), toSave);
      dispatch({ type: EDIT_CAR, payload: { method, car: toSave } });
      return { success: true, id: carId };
    }

    // Update
    const placa = car.placa ? String(car.placa) : '';
    if (placa) {
      const claim = await requestUpdateVehiclePlate(car.id, placa);
      if (!claim.success) {
        return { success: false, error: claim.error === 'plate_already_exists' ? 'plate_already_exists' : (claim.error || 'plate_check_failed') };
      }
    }
    const toSave = { ...car };
    if (norm) toSave.placa = norm;
    delete toSave.tableData;
    set(carEditRef(toSave.id), toSave);
    dispatch({ type: EDIT_CAR, payload: { method, car: toSave } });
    return { success: true };
  }

  export const updateUserCarWithImage = (newData, carImageBlob, crlvAttachment = null) => async (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage,
      carCrlv          // <-- referência para o CRLVe
    } = firebase;

    const norm = normPlate(newData.placa);

    // Guarda local imediata contra placas já existentes nos carros do motorista
    if (norm) {
      const existingCars = store.getState().carlistdata?.cars || [];
      const duplicateLocal = existingCars.find(
        (c) => c && normPlate(c.placa) === norm
      );
      if (duplicateLocal) {
        return { success: false, error: 'plate_already_exists' };
      }
    }

    // Gera ID do carro
    const carId = push(carAddRef).key;

    // Reserva atômica da placa antes de subir imagem/gravar.
    const placa = newData.placa ? String(newData.placa) : '';
    if (placa) {
      const claim = await requestUpdateVehiclePlate(carId, placa);
      if (!claim.success) {
        return { success: false, error: claim.error === 'plate_already_exists' ? 'plate_already_exists' : (claim.error || 'plate_check_failed') };
      }
    }
    if (norm) newData.placa = norm;

    try {
      // 1. Upload da imagem do carro
      await uploadBytesResumable(carImage(carId), carImageBlob);
      if (carImageBlob && carImageBlob.close) carImageBlob.close();
      const carImageUrl = await getDownloadURL(carImage(carId));
      newData.car_image = carImageUrl;

      // 2. Upload do anexo CRLVe (se existir)
      let crlvUrl = null;
      if (crlvAttachment && crlvAttachment.blob) {
        try {
          await uploadBytesResumable(carCrlv(carId), crlvAttachment.blob);
          crlvUrl = await getDownloadURL(carCrlv(carId));
          newData.crlvAttachmentUrl = crlvUrl;
          newData.crlvAttachmentName = crlvAttachment.name;
          newData.crlvAttachmentType = crlvAttachment.type;
        } catch (crlvError) {
          // Falha no upload do CRLVe não interrompe o fluxo principal
        }
      }

      // Salva o nó do carro no Realtime Database
      await set(child(carAddRef, carId), newData);

      // Se o carro for ativo, atualiza o perfil do motorista
      if (newData.active) {
        const updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info ? newData.other_info : "",
          car_image: carImageUrl,
          carApproved: newData.approved,
          state: newData.state || null,
          fuelType: newData.fuelType || null,
          color: newData.color || null,
          crlv: newData.crlv || null,
          chassis: newData.chassis || null,
          manufactureYear: newData.manufactureYear || null,
          placa: newData.placa || null,
          ownVehicle: newData.ownVehicle || null,
          city: newData.city || null,
          updateAt: new Date().getTime()
        };
        await update(singleUserRef(auth.currentUser.uid), updateData);
      }
      return { success: true, id: carId };
    } catch (error) {
      // Se falhar antes de criar o nó do carro, libera a placa reservada para não deixar índice órfão
      if (placa) {
        try { await requestUpdateVehiclePlate(carId, ''); } catch (e) { /* ignore */ }
      }
      throw error;
    }
  };